import React from 'react';
import '../../entrydoor.css';


const KeyValueList = ({ data = [], title = '' }) => {
  return (
    <div className="bg-white border border-gray-300 rounded-md p-4 shadow-sm max-w-md">
      {/*title && <h3 className="text-lg font-semibold mb-3">{title}</h3>*/}
      <div className="space-y-3 text-sm text-gray-800">
        {data.map((item, index) => (
          <div key={index} style={{ display: 'flex', whiteSpace: 'nowrap', marginBottom: '4px' }}>
            <span className="font-medium" style={{ flexShrink: 0 }}>{item.key}:</span>
            <span style={{ marginLeft: '8px' }}>{item.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default KeyValueList;
